import React, { Component } from "react";
import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

import ConsultaUsuarioLogResultado from "./ConsultaUsuarioLogResultado";
import DataUtil from "../../../actions/data";

class ConsultaUsuarioLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.ultimoDiaMes(),
        usuarioId: 0,
        tipo: 0
      },
      resultado: [],
      usuarios: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    let consulta = { ...this.state.consulta };
    consulta[event.target.name] = event.target.value;
    this.setState({ consulta: consulta });
  }

  componentDidMount() {
    UI.loader("show", "Um momento...");
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários à vincular ...
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach(usuario => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.periodoDe)) {
      data.periodoDe = DataUtil.primeiroDiaMes();
    }
    if (!DataUtil.validarData(data.periodoAte)) {
      data.periodoAte = DataUtil.ultimoDiaMes();
    }

    UI.loader("show", "Um momento...");
    API.post("/acesso/logs", data).then(
      function (json) {
        this.setState({ resultado: json.data });
        UI.loader("hide");
      }.bind(this)
    );
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">REGISTROS DE ACESSO</h4>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Período De</label>
                        <InputMask
                          placeholder="PERÍODO DE"
                          name="periodoDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Período Até</label>
                        <InputMask
                          placeholder="PERÍODO ATÉ"
                          name="periodoAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Usuario</label>
                        <select
                          name="usuarioId"
                          className="form-control"
                          value={this.state.consulta.usuarioId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(
                            function (usuario, i) {
                              return (
                                <option key={usuario.id} value={usuario.id}>
                                  {usuario.nome}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Tipo</label>
                        <select
                          name="tipo"
                          className="form-control"
                          value={this.state.consulta.formato}
                          onChange={this.handleChange}
                        >
                          <option value={0}>QUALQUER LOG</option>
                          <option value={1}>LOGIN</option>
                          <option value={2}>LOGOUT</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp;
                            Pesquisar
                        </button>
                      </div>
                    </div>
                    <ConsultaUsuarioLogResultado resultado={this.state.resultado} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ConsultaUsuarioLog;
